import createApiClients from "@wine2trace/auth/createApiClients";
import { BASE_URL } from "../services/constants";

// 2 instances: the private one gets the interceptors (token, refresh, errors) from components/ApiInterceptors
const { api, apiPrivate } = createApiClients(BASE_URL);

export default api;
export const axiosPrivate = apiPrivate;
